fx.ns("repositories", class LayoutsRepository extends fx.ModelArray {

    constructor()
    {
        super([]);
        this.endpoint = "/app/layouts";
        this._loaded = {};
        this._layoutsFrom = 0;
    }
    
    get more()
    {
        return this._layoutsFrom;
    }

    get requestDefaultParams()
	{
		return {connectionid : fx.get("connectionid")};
	}

    get basicLayouts()
    {
        if (!this._basicLayouts || this._basicLayouts.length == 0)
            this._basicLayouts = this.filter( function(layout) { return layout.themeid == -1;} );

        return this._basicLayouts;
    }

    get themeLayouts()
    {
        if (!this._themeLayouts || this._themeLayouts.length == 0)
            this._themeLayouts = this.filter( function(layout) { return layout.themeid != -1;} );

        return this._themeLayouts;
    }

    getLayoutForTheme(themeid)
    {
        return this.filter( function(layout) { return layout.themeid == themeid;} );
    }

    get simpleThemeLayouts()
    {
        if (!this._simpleThemeLayouts || this._simpleThemeLayouts.length == 0)
            this._simpleThemeLayouts = this.filter( function(layout) { return layout.themeid != -1 && layout.doublepage == 0 && layout.typeid == 1;} );

        return this._simpleThemeLayouts;
    }

    get doubleThemeLayouts()
    {
        if (!this._doubleThemeLayouts || this._doubleThemeLayouts.length == 0)
            this._doubleThemeLayouts = this.filter( function(layout) { return layout.themeid != -1 && layout.doublepage == 1;} );

        return this._doubleThemeLayouts;
    }

    frontCoverLayout(themeid)
    {
        let layout = this.filter(function(layout){ return layout.themeid == themeid && layout.side == "right" && layout.typeid == 6})[0];

        if (!layout)
            layout = this.filter(function(layout){ return layout.themeid == themeid && layout.side == "right"})[0];

        if (!layout)
            layout = this.filter(function(layout){ return layout.side == "right"})[0];

        return layout;
    }

    backCoverLayout(themeid)
    {
        let layout = this.filter(function(layout){ return layout.themeid == themeid && layout.side == "left" && layout.typeid == 6})[0];

        if (!layout)
            layout = this.filter(function(layout){ return layout.themeid == themeid && layout.side == "left"})[0];

        if (!layout)
            layout = this.filter(function(layout){ return layout.side == "left"})[0];

        return layout;
    }

    init(data)
    {
        super.init(data && data.data ? data.data : data);

        if (data && data.more !== false)
            this._layoutsFrom = data.more;

        if (data && data.data && data.more !== false && data.data.length > 0)
        {
            this._loaded[ data.data[0].themeid + "-" + data.data[0].shape ] = data.more;
            this._initialThemeid = data.data[0].themeid != -1 ? data.data[0].themeid : 0;
        }
    }

    getLayoutForPage(page, number, simple, side, themeid)
    {
        let index = number + ((!side || side == "left") ? 0 : 1);
        let layouts = (page.isFirstPage || page.isLastPage || simple) ? this.simpleThemeLayouts : this.doubleThemeLayouts;

        layouts = layouts.filter(function(layout){ return layout.themeid == themeid; });
        if (layouts.length == 0) return;
        
        while (index >= layouts.length)
            index = index - layouts.length;

        return layouts[index];
    }

    getDefaultLayout()
    {
        let defaultLayout;
        for(let i = 0; i < this.basicLayouts.length; i++)
        {
            let layout = this.basicLayouts.getItemAt(i);
            if (layout.isdefault)
            {
                defaultLayout = layout;
                break;
            }
        }
        if (!defaultLayout)
            defaultLayout = this.basicLayouts.getItemAt(0);

        return defaultLayout;
    }

    getLayoutsWithPhotosDimensions(number, horizontal, vertical, themeid)
    {
        let layouts = this.simpleThemeLayouts.find({num_photos : number, horizontal : horizontal, vertical : vertical, themeid : themeid}, false);

        if (layouts.length == 0)
            layouts = this.basicLayouts.find({num_photos : number, horizontal : horizontal, vertical : vertical, target : "ia"}, false);
        
        if(layouts.length == 0)
        {
            while (layouts.length == 0 && number > 0)   
                layouts = this.basicLayouts.find({num_photos : number--, target : "ia"}, false);
        }

        return layouts;
    }

    getLayoutsWithPhotos(number, themeid)
    {
        let basicLayout = this.basicLayouts.find({num_photos : number, target : "", accountid : 0}, false);
        let themeLayouts = this.simpleThemeLayouts.find({num_photos : number, themeid : themeid, accountid : 0}, false);
        if (themeid == 0 || themeLayouts.length < 2)
            return basicLayout;

        return themeLayouts;

        //let foundLayout;
        //let layouts = [];
        
        /*for (let i = 0; i < this.simpleThemeLayouts.length; i++)
        {
            let layout = this.simpleThemeLayouts.getItemAt( i );

            if (layout.num_photos == number)
            {
                //foundLayout = layout;
                //break;
                layouts.push(layout);
            }
        }*/
/*
        //if(!foundLayout)
        //{
            for (let i = 0; i < this.basicLayouts.length; i++)
            {
                let layout = this.basicLayouts.getItemAt( i );

                if (layout.num_photos == number && layout.components.length > 0)
                {
                    //foundLayout = layout;
                    //break;
                    layouts.push(layout);
                }
            }

       // }
    
        //return foundLayout;
        return layouts;*/
    }

    /*loadNextLayouts( themeids, shape, numphotos, all )
    {
        let code = [themeid + "-" + shape + "-" + numphotos];
        
        if (!this._loaded[ code ])
        {
            this.post({ action : "search", search :  numphotos, themeids :  themeids, shape : shape, all : all ? 1 : 0}, this._loadedLayouts);
            this._loaded[code] = true;
        }
        else
            this._loadedLayouts();
    }*/

    loadMore(model)
    {
        this.loadThemeLayouts( model, true);    
    }

    loadThemeLayouts( model, from, reset)
    {
        if (reset)
        {
            this._loaded = {};
            this._initialThemeid = model.theme.id;
            //this.removeAll(true);
        }

        if (from !== true && from !== undefined)
            this._layoutsFrom = from;
        
        let code = this._layoutsFrom + "-" +  model.book.shape_option;

        if (from === true) // case when load more, but some themes already loaded
        {
            let nextThemeId;    
            while(this._loaded[ code ] && nextThemeId !== this._layoutsFrom)
            {
                nextThemeId = this._loaded[ code ];
                code = nextThemeId + "-" + model.book.shape_option;
            }

            if (!this._loaded[ code ] && nextThemeId)
                this._layoutsFrom = nextThemeId;
        }

        if (this._layoutsFrom === false || this._loaded[ code ] === false)
        {
            this._layoutsFrom = false;
            this.event("theme-layouts-loaded");
        }
        else
        if (!this._loaded[ code ])
            this.post({ action : "themelayouts", themeid :  this._initialThemeid, shape : model.book.shape_option, from : this._layoutsFrom}, this._loadedThemeLayouts);
        else
        {
            this._layoutsFrom = this._loaded[ code ];
            this.event("theme-layouts-loaded");
        }
    }

    _loadedThemeLayouts(data)
    {
        if (data.error)
        {
            this.event("theme-layouts-error");
        }
        else
        {
            if (data.data && data.data.length > 0)
            {
                let code = data.data[0].themeid + "-" + data.data[0].shape;
                this._loaded[ code ] = data.more;
                
                this._layoutsFrom = data.more;
                this.addItem( data.data, true );
                this.event("theme-layouts-loaded");
            }
            else
                this.event("theme-layouts-error");
        }
    }

    loadLayouts( themeid, productType, shape, numphotos, all )
    {
        let code = [themeid + "-" + productType + "-" + shape + "-" + numphotos];
        
        if (!this._loaded[ code ])
        {
            this.post({ action : "search", search :  numphotos, productType : productType, themeid :  themeid, shape : shape, all : all ? 1 : 0}, this._loadedLayouts);
            this._loaded[code] = true;
        }
        else
            this._loadedLayouts(code);
    }

    _loadedLayouts(data)
    {
        if (data.error)
        {
            this.event("layouts-loaded-error");
            return;
        }

        if (typeof data == "string")
        {  
            data = this._loaded[data];
            this.trigger({type:"updated", action : new fx.Action("update")});
        }    
        else
            this.addItem( data );

        this._layoutsFrom = 0;
        this._themeLayouts = null;
        this._simpleThemeLayouts = null
        this._doubleThemeLayouts = null;

        this.event("layouts-loaded");
    }

    use(id, use)
    {
        let layout = super.find({id : id});
        if (layout)
            layout.number = use ? (layout.number + 1) : (layout.number - 1);
    }


    // --- custom

    hasCustomLayouts()
    {
        let has = false;
        for (let i = 0; i < this.length; i++)
        {
            if (this.getItemAt(i).themeid == -1 && this.getItemAt(i).accountid)
            {
                has = true;
                break;
            }
        }
        return has;
    }

    createCustomLayout(page, side, thumb /*html*/, pageWidth, pageHeight, sliceWidth, shape, accountid)
    {
        let layout = {  shape : shape,
                        doublepage : 0,
                        position : 0,
                        num_photos : 0,
                        num_texts : 0,
                        themeid : -1,
                        visible : 1,
                        bgcolor : page.bgcolor,
                        bgcolorleft : page.bgcolorleft,
                        bgcolorright : page.bgcolorright,
                        width : pageWidth,
                        height : pageHeight,
                        page_id : 0,
                        book_id : 0,
                        side : "",
                        typeid :  page.typeid,
                        accountid : accountid    
                    };
            
        let components = [];
        for (let i = 0; i < page.components.length; i++)
        {
            let component = page.components.getItemAt( i );
            let bounding = fx.graphics.getBoundingRect(component, component.rotation);

            if ( component.isBackground)
            {
                if (component.creation != side)
                    continue;
            }
            else
            if (  (side == "left" && bounding.x >= pageWidth) || // TODO : slice ?
                    (side == "right" && bounding.x + bounding.width <= pageWidth) 
                )    
                continue;

            if (component.isPhoto)
                layout.num_photos++;
            else
            if (component.isText)
                layout.num_texts++;

           

            let json = component.JSON;
            delete json.zoom;
            delete json.creation_element_id;
            delete json.x_inner;
            delete json.y_inner;
            delete json.width_inner;
            delete json.height_inner;
            delete json.rotation_inner;
            delete json.line_height;
            delete json.lastaction;
            delete json.contentlines;

            if (side == "right")
            {
                json.x -= pageWidth;
                if (page.isCover)
                    json.x -= sliceWidth;
            }
            

            if (component.isPhoto)
                json.content = "";

            components.push( json );
        }

        
        let data = {    'action' : "customlayout",
                        'platform': "desktop",
                        //'code': html ,
                        'thumb' : thumb,
                        'side': side ,
                        'width': pageWidth ,
                        'height': pageHeight ,
                        'slice': page.isCover ? sliceWidth : 0,
                        'layout': layout ,
                        'components': components };

        this.post(data, this._createCustomLayout);


        this.event("custom-layout-creating");
    }

    _createCustomLayout(data)
    {
        if (data.error)
            this.event("custom-layout-error");
        else
        {
             let layout = this.addItem( new models.ThemeLayout(data) );
             this.event("custom-layout-created", layout);
        }
    }

});